import { render, staticRenderFns } from "./Title_Customer.vue?vue&type=template&id=00f7af0d&scoped=true&"
import script from "./Title_Customer.vue?vue&type=script&lang=js&"
export * from "./Title_Customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f7af0d",
  null
  
)

export default component.exports